'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _jsx = require('@babel/runtime/helpers/jsx');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var React = require('react');
var classNames = require('classnames');
var warning = require('@andes/common/build/utils/warning');
require('@andes/common/build/utils/includes');
var context = require('@andes/context');
var common = require('@andes/common');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
const computeBadgeColorProps = _ref => {
  let {
    badge
  } = _ref;
  if (!badge) return undefined;
  const {
    type,
    color
  } = badge;
  if (color) return color;
  switch (type) {
    case 'neutral':
      return 'accent';
    case 'generic':
      return 'gray';
    case 'success':
      return 'green';
    case 'warning':
      return 'orange';
    case 'error':
      return 'red';
    default:
      return 'accent';
  }
};
var computeBadgeColorProps$1 = computeBadgeColorProps;
const namespace$1 = 'andes-thumbnail';
const iconColors = {
  neutral: 'rgba(0, 0, 0, 0.9)',
  loud: '#fff',
  quiet: '#3483fa',
  disabled: 'rgba(0, 0, 0, 0.25)'
};
const getBadgeSizeByThumbnailSize = size => {
  if (size === '80' || size === '72' || size === '64') return 'large';
  return 'small';
};
function isIcon(children) {
  if (/*#__PURE__*/React.isValidElement(children) && typeof children.type === 'function') {
    return children.type.name === 'Asset';
  }
  return false;
}
const isImage = children => {
  if (/*#__PURE__*/React.isValidElement(children)) {
    return children.type === 'img';
  }
  return false;
};
function isText(children) {
  if (/*#__PURE__*/React.isValidElement(children)) {
    return !children.props.src && !isIcon(children);
  }
  return false;
}
const verifyBadgeType = (size, badge) => {
  const isDot = badge.type.displayName === 'Dot';
  if (isDot && (size === '24' || size === '32') || !isDot && size !== '24' && size !== '32') {
    return badge;
  }
  warning__default["default"](!isDot, "".concat(size, " should use Notification or Pill Badges"));
  return false;
};
const Thumbnail = /*#__PURE__*/function () {
  const Thumbnail = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      'aria-label': ariaLabel,
      badge,
      children,
      className,
      disabled = false,
      hierarchy = 'neutral',
      id,
      modifier = 'circle',
      size = '48',
      srLabel
    } = _ref;
    const componentId = context.useId(id);
    const badgeColor = computeBadgeColorProps$1({
      badge: badge === null || badge === void 0 ? void 0 : badge.props
    });
    const computedSrLabel = srLabel || ariaLabel;
    const computedHierarchy = hierarchy === 'default' ? 'neutral' : hierarchy;
    const classes = classNames__default["default"](namespace$1, "".concat(namespace$1, "--").concat(modifier), "".concat(namespace$1, "--").concat(size), {
      ["".concat(namespace$1, "__badge")]: badge,
      ["".concat(namespace$1, "__badge-").concat(badgeColor)]: badgeColor,
      ["".concat(namespace$1, "--").concat(computedHierarchy)]: isIcon(children) || isText(children),
      ["".concat(namespace$1, "--").concat(computedHierarchy, "-disabled")]: (isIcon(children) || isText(children)) && disabled
    }, className, {});
    const a11yProps = _objectSpread__default["default"](_objectSpread__default["default"]({}, !isImage(children) && {
      'aria-hidden': !!computedSrLabel
    }), {}, {
      title: computedSrLabel
    });
    const getColor = () => {
      const {
        color
      } = children.props;
      if (color && color !== 'rgba(0, 0, 0, 0.9)') return color;
      return iconColors[disabled ? 'disabled' : computedHierarchy];
    };
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "".concat(namespace$1, "-container"),
      ref: ref
    }, /*#__PURE__*/_jsx__default["default"]("div", {
      className: classes
    }, void 0, React__default["default"].Children.only(isIcon(children) ? /*#__PURE__*/React__default["default"].cloneElement(children, _objectSpread__default["default"]({
      color: getColor()
    }, a11yProps)) : /*#__PURE__*/React__default["default"].cloneElement(children, _objectSpread__default["default"]({}, a11yProps))), computedSrLabel && /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {}, void 0, computedSrLabel)), badge && verifyBadgeType(size, badge) && /*#__PURE__*/React__default["default"].cloneElement(badge, {
      size: getBadgeSizeByThumbnailSize(size),
      id: badge.props.id || "".concat(componentId, "-thumbnail-badge")
    }));
  });
  Thumbnail.displayName = 'Thumbnail';
  return Thumbnail;
}();
var Thumbnail$1 = Thumbnail;
const TYPE_GRID = 'grid';
const SIZE_16 = '16';
const SIZE_24 = '24';
const SIZE_32 = '32';
const SIZE_40 = '40';
const SIZE_48 = '48';
const SIZE_72 = '72';
const SIZE_80 = '80';
const namespace = 'andes-thumbnail-multiple';
const getChildrenSize = (type, containerSize) => {
  let childrenSize;
  const isLargeContainer = containerSize === SIZE_72 || containerSize === SIZE_80;
  const isSmallContainer = containerSize === SIZE_40 || containerSize === SIZE_48;
  if (type === TYPE_GRID) {
    if (isLargeContainer) {
      childrenSize = SIZE_32;
    } else if (isSmallContainer) {
      childrenSize = SIZE_16;
    } else {
      childrenSize = SIZE_24;
    }
  } else {
    childrenSize = containerSize;
  }
  return childrenSize;
};
const ThumbnailMultiple = /*#__PURE__*/function () {
  const ThumbnailMultiple = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      children,
      className,
      containerSize = '56',
      id,
      modifier = 'circle',
      overflow,
      type = 'grid'
    } = _ref;
    const componentId = context.useId(id);
    const classes = classNames__default["default"](namespace, "".concat(namespace, "--").concat(type), "".concat(namespace, "--").concat(type, "-").concat(containerSize), className);
    const childSize = getChildrenSize(type, containerSize);
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: classes,
      ref: ref
    }, React__default["default"].Children.map(children, (child, index) => /*#__PURE__*/React__default["default"].cloneElement(child, {
      size: childSize,
      modifier,
      id: child.props.id || "".concat(componentId, "-").concat(index)
    })), overflow && /*#__PURE__*/_jsx__default["default"](Thumbnail$1, {
      id: "".concat(componentId, "-overflow"),
      className: "".concat(namespace, "--overflow"),
      size: childSize,
      modifier: modifier
    }, void 0, /*#__PURE__*/_jsx__default["default"]("span", {}, void 0, "+", overflow)));
  });
  ThumbnailMultiple.displayName = 'ThumbnailMultiple';
  return ThumbnailMultiple;
}();
var ThumbnailMultiple$1 = ThumbnailMultiple;
exports.Thumbnail = Thumbnail$1;
exports.ThumbnailMultiple = ThumbnailMultiple$1;
exports["default"] = Thumbnail$1;
